import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=08bac203"
import script from "./ServerError.vue?vue&type=script&lang=ts"
export * from "./ServerError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports